import { useEffect, useContext, useState } from "react";

import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import axios from "axios";
import moment from "moment";
import _ from "lodash";

import HrNotifications from "../../components/hotelRepresentative/HrNotifications";
import HrCertification from "../../components/hotelRepresentative/HrCertification";

const HrDashboard = (props) => {
  const { userData, isCertified } = useContext(UserContext);

  const { certificate } = userData;

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  /* Classes for specific status */
  const statusClasses = {
    "In-Process": "status-pill inline-block bg-yellow-100 text-yellow-800",
    Pending: "status-pill inline-block bg-pink-50 text-pink-700",
    Completed: "status-pill inline-block bg-gray-200 text-gray-700",
  };
  /* Labels for status */
  const getStatusLabel = (status) => {
    const code = Number(status);

    if (code === 0 || code === 1) return "Pending";
    if (code >= 2 && code <= 6) return "In-Process";
    if (code === 7 || code === 8) return "Completed";

    return "Unknown";
  };

  const renderBell = (st) => {
    const redStatus = [1, 2, 3, 5];
    return (
      <div>
        <i className={`fas fa-bell text-${redStatus.includes(Number(st)) ? "red" : "green"}-500`}></i> {status[st + 1]}
      </div>
    );
  };

  const hotelDetailsFromAttrs = (attrs) => {
    return attrs.split("#");
  };

  const [brandDetails, setBrandDetails] = useState([]);
  /* Getting Hotel Details */
  useEffect(() => {
    axios
      .get(Utils.apiUrl(`hr/brandDetail`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setBrandDetails(res.data.brand);
        }
        //console.log(frmMess);
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  /* Getting status for number */
  const [status, setStatus] = useState([]);
  useEffect(() => {
    axios
      .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setStatus(res.data.statuses);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  const [activePhotoshoot, setActivePhotoshoot] = useState([]);
  useEffect(() => {
    if (isCertified()) {
      axios
        .get(Utils.apiUrl(`photoshoot/listing?sortBy=created_at&sortDir=desc&limit=1`), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setActivePhotoshoot(res.data.data);
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
    }
  }, []);

  const nextAction = (status) => {
    const code = parseInt(status);
    if (code >= 1 && code <= 2) return "Shot-list";
    if (code >= 3 && code <= 4) return "Styling deck";
    if (code >= 5 && code <= 4) return "Recce deck";
    else return "View Details";
  };

  return (
    <>
      <div className="container mx-auto px-8 py-8">
        <div className="h1-wrapper">
          <h1 className="text-3xl font-bold text-gray-800">Hotel Photography Lead</h1>
          {isCertified() && (
            <>
              <div className="certification-icon-header valid" title="Certification Status">
                <i className="fas fa-certificate"></i>
              </div>
              <div className="ml-3 text-sm text-gray-600">
                <p className="text-md font-bold">Photography Course Certification Complete</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-green-500">Valid till:</span>
                  <span className="badge flex items-center gap-2">
                    <i className="fas fa-calendar-alt" style={{ color: "#FF9362" }}></i>
                    {moment(certificate.expires_by).format("DD-MMM-YYYY")}
                  </span>
                </div>
              </div>
            </>
          )}
          {!isCertified() && (
            <>
              <div className="certification-icon-header invalid" title="Certification Status">
                <i className="fas fa-exclamation-triangle"></i>
              </div>
              {_.get(certificate, "attempted", false) && (
                <div>
                  <strong>Expired on:</strong> {moment(certificate.expires_by).format("DD-MMM-YYYY")}
                </div>
              )}
              {!_.get(certificate, "attempted", false) && <>Not yet attempted</>}
            </>
          )}
        </div>

        {/* <!-- Notifications Section --> */}
        {/* <HrNotifications /> */}
        {/* <!-- Certification Status --> */}
        {/*<HrCertification />*/}

        {/* <!-- Hotel Details Section --> */}
        <div className="dashboard-section">
          <div className="section-title flex justify-between items-center">
            <div>
              <i className="fas fa-building"></i>
              Hotel Details
            </div>
            {/* <a href="hotel-representative-first-login" className="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90">
                    <i className="fas fa-exchange-alt"></i>
                    <span>Switch Brand</span>
                </a> */}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="brand-card p-6">
              <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Hotel Name</p>
              <p className="text-xl font-bold text-gray-800">{brandDetails.hotel}</p>
            </div>
            <div className="brand-card p-6">
              <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Marsha Code</p>
              <p className="text-xl font-bold text-gray-800 tracking-widest">{brandDetails.marsha}</p>
            </div>
            <div className="brand-card p-6">
              <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Brand Name</p>
              <p className="text-xl font-bold text-gray-800">{brandDetails.brand}</p>
            </div>
          </div>
        </div>

        {!isCertified() && (
          <div class="flex items-start gap-3 rounded-lg border border-yellow-300 bg-yellow-50 p-4 text-yellow-800">
            <svg class="h-6 w-6 flex-shrink-0 text-yellow-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v4m0 4h.01M5.07 19h13.86c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.34 16c-.77 1.33.19 3 1.73 3z"
              />
            </svg>

            <div>
              <h3 class="font-semibold">Certification Required</h3>
              <p class="mt-1 text-sm">You must complete your certification before proceeding. Please get certified to unlock this feature.</p>

              <a
                href="/get-certified"
                class="mt-3 inline-block rounded-md bg-yellow-600 px-4 py-2 text-sm font-medium text-white hover:bg-yellow-700"
              >
                Get Certified
              </a>
            </div>
          </div>
        )}

        {/* <!-- Photoshoot Request Creation Section --> */}
        {isCertified() && activePhotoshoot.length == 0 && (
          <>
            <div className="dashboard-section">
              <div className="section-title">
                <i className="fas fa-camera-retro"></i>
                Photoshoot Request Details
              </div>
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-lg border border-gray-200">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Hotel Name</p>
                    <p className="text-lg font-bold text-gray-800">{brandDetails.hotel}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Create Photoshoot Request</p>
                    <p className="text-lg font-bold text-gray-800">
                      <a
                        href="hotel-representative-photoshoot-requirement-form"
                        className="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90"
                      >
                        <i className="fa-regular fa-camera"></i>
                        <span>Photoshoot Request</span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* <!-- Photoshoot Request Section --> */}
        {isCertified() && activePhotoshoot.length > 0 && (
          <>
            <div className="dashboard-section">
              <div className="section-title">
                <i className="fas fa-camera-retro"></i>
                Photoshoot Request Details
              </div>
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-lg border border-gray-200">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Hotel Name</p>
                    <p className="text-lg font-bold text-gray-800">{brandDetails.hotel}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide mb-2">Date Range</p>
                    <p className="text-lg font-bold text-gray-800">
                      <i className="fas fa-calendar-alt text-gray-600"></i>
                      {formatDate(activePhotoshoot[0].date_from)} to {formatDate(activePhotoshoot[0].date_to)}
                    </p>
                  </div>
                </div>
                <div className="mt-6 pt-6 border-t border-gray-300 flex items-center justify-between">
                  <p className="text-sm text-gray-600 font-semibold uppercase tracking-wide">
                    Status: {status[activePhotoshoot[0].status]}
                    {renderBell(activePhotoshoot[0].status)}
                  </p>
                </div>

                {_.get(activePhotoshoot, "0.status", 0) > 0 && (
                  <div className="mt-4">
                    <a
                      href={`hotel-representative-photoshoot-details/${activePhotoshoot[0].id}`}
                      className="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90"
                    >
                      <i className="fas fa-file-alt"></i>
                      <span>{nextAction(activePhotoshoot[0].status)}</span>
                    </a>
                  </div>
                )}

                {_.get(activePhotoshoot, "0.status", 0) > 0 && <div className="mt-4"></div>}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default HrDashboard;
